import { getTenantName, getUserDetails } from "./authUtils";
import { trackEvent } from "./monitoring";

const user = getUserDetails();
const tenantName = getTenantName();

export const apiTrace = (apiRes) => {
  const data = {
    api: apiRes.request.responseURL,
    method: apiRes.config.method,
    status: apiRes?.status >= 400 ? "Failed": "Success",
    appEnvironment: getEnv(),
    traceId: apiRes.headers?.["x-b3-traceid"],
    responseTime: apiRes.responseTime,
    orgCode: user?.OrgCode,
    orgName: tenantName,
    userId: user?.Id,
  };
  trackEvent(
    extractApiWord(apiRes.request.responseURL) + " WebRequests",
    data
  );
};
const extractApiWord = (url) => {
  const match = /api\/([^/]+)/.exec(url);
  if (match && match[1]) return match[1];
  else return null;
};

const getEnv = () => {
  const host = window.location.host;
  if (host.endsWith("marketxpander.net")) {
    return "dev";
  } else if (host.endsWith("crm4b2c.com")) {
    return "test";
  } else if (host.endsWith("lsq-staging.com")) {
    return "stage";
  } else if (host.endsWith("leadsquared.com")) {
    return "prod";
  } else {
    return "local";
  }
};

export const getRegion = () => {
  const host = window.location.host;
  if (host.includes("us11"))            return "us-east-1";
  if (host.includes("ca12"))            return "ca-central-1";
  if (host.includes("ir31"))            return "eu-west-1";
  if (host.includes("in22"))            return "ap-south-2";
  if (host.endsWith("crm4b2c.com"))     return "ap-southeast-1";
  if (host.endsWith("lsq-staging.com")) return "ap-south-1";
  if (host.endsWith("leadsquared.com")) return "ap-south-1";
  return "local";
};